module.exports = "/dist/fonts/profile-round.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/resources/profile-round.svg
// module id = 438
// module chunks = 0